import React from 'react';

export default function TextFieldWithCounter({
  id,
  value,
  onChange,
  placeholder,
  minLength,
  maxLength,
  className = ''
}) {
  const text = typeof value === 'string' ? value : '';
  const charCount = text.length;

  const inRange = (() => {
    if (typeof minLength === 'number' && charCount < minLength) return false;
    if (typeof maxLength === 'number' && charCount > maxLength) return false;
    return true;
  })();

  const borderClass = 'border-lightGrey';
  const counterClass = inRange ? 'text-gray' : 'text-[#F04438]';

  return (
    <div className="relative">
      <input
        id={id}
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        minLength={minLength}
        maxLength={maxLength}
        className={`w-full rounded-[10px] border-1p3 px-4 xl:py-3.5 py-3 text-base text-dark-blue ${borderClass} ${className}`}
        required
      />
      {typeof maxLength === 'number' ? (
        <span className={`absolute right-2 bottom-0 text-xs font-medium ${counterClass}`}>
          {charCount}/{maxLength}
        </span>
      ) : (
        <span className={`absolute right-2 bottom-0 text-xs font-medium ${counterClass}`}>
          {charCount}
        </span>
      )}
    </div>
  );
}


